"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePaletteValueToRgbaString = usePaletteValueToRgbaString;
var _react = require("react");
var _cdsCommon = require("@cbhq/cds-common");
var _useSpectrumConditional = require("@cbhq/cds-common/hooks/useSpectrumConditional");
var _paletteValueToRgbaString = require("@cbhq/cds-common/palette/paletteValueToRgbaString");
/** Returns a function to retrieve the rgba string for a palette value. */
function usePaletteValueToRgbaStringConverter() {
  const spectrum = (0, _cdsCommon.useSpectrum)();
  /** Fallback value if we are unable to access spectrum color */
  const fallbackColor = (0, _useSpectrumConditional.useSpectrumConditional)({
    light: '255,255,255',
    dark: '0,0,0'
  });
  return (0, _react.useCallback)(paletteValue => {
    const rgbaString = (0, _paletteValueToRgbaString.paletteValueToRgbaString)(paletteValue, spectrum);
    return paletteValue ? rgbaString : fallbackColor;
  }, [fallbackColor, spectrum]);
}

/**
 * Get rgba string for a palette value.
 * Returns an rgba string or function to get an rgba string.
 */

function usePaletteValueToRgbaString(value) {
  const convert = usePaletteValueToRgbaStringConverter();
  return (0, _react.useMemo)(() => {
    if (value) {
      return convert(value);
    }
    return convert;
  }, [convert, value]);
}